// 登录
import { useState } from "react"
import { useHistory } from "react-router"
import { set } from "browser-cookies"
import { useLazyQuery } from "@apollo/react-hooks"
import { homePath } from "Views/Home/hooks"
import { TOKEN_NAME, UID_NAME } from "Methods/user"
import { generateQuery } from "Methods/query"
import request from "Methods/request"
// 用户登录
export const useLogin = () => {
    const [ username, setUsername ] = useState("")
    const [ password, setPassword ] = useState("")
    const [ error, setError ] = useState({
        username: false,
        password: false,
    })
    const [ helperText, setHelperText ] = useState({
        username: "",
        password: "",
    })
    const history = useHistory()
    const login = async () => {
        const body = { username, password }
        try {
            const res = await request.post(`/apis/user/login`, body)
            const { data } = res || {}
            const { access_token, uid } = data
            set(TOKEN_NAME, access_token)
            set(UID_NAME, uid)
            history.push(homePath)
        } catch ({ response: { data = {} } = {}, message }) {
            const { error_code: errorCode } = data
            setError({
                username: errorCode === "username_is_wrong",
                password: errorCode === "password_is_wrong",
            })
            setHelperText({
                username: errorCode === "username_is_wrong" ? data.message : "",
                password: errorCode === "password_is_wrong" ? data.message : "",
            })
        }

    }
    const handleChangeUsername = (event: any) => setUsername(event.target.value)
    const handleChangePassword = (event: any) => setPassword(event.target.value)
    const handleSubmit = async () => {
        if (username && password) {
            await login()
        } else {
            setError({
                username: !username,
                password: !password,
            })
            setHelperText({
                username: !username ? "请输入用户名" : "",
                password: !password ? "请输入密码" : "",
            })
        }
    }
    return {
        username, password,
        error, helperText,
        handleChangePassword,
        handleChangeUsername,
        handleSubmit,
    }
}
// 缓存用户信息
export const useCacheUser = (loginData: { access_token: string, uid: string }) => {
    const { uid } = loginData
    const variables = { limit: 1, offset: 0, where: { uid: { _eq: uid }}}
    const query = generateQuery("users", `
        hidden
        role {
            name
            role_name
            menus (order_by: {id: asc}) {
                id
                name
                url
                icon
                child_menus {
                    id
                    name
                    url
                    icon
                    seq_num
                }
                parent_id
            }
            role_privileges {
                privilege {
                    id
                    obj_type
                    menu {
                        id
                        name
                        parent_menu {
                            id
                            name
                        }
                    }
                    resource {
                        id
                        name
                        description
                    }
                    action {
                        id
                        name
                        action_code
                    }
                }
            }
        }
        department {
            name
            type_name
        }
    `)
    const [ fetchUser, { data } ] = useLazyQuery(query, { variables })
    const { users: [ user ] = [] } = data || {}

    return { fetchUser, user }
}
